import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import {
  teacherDisplayName,
  useBindLoggedInToTeacher,
  useTeacherInvite,
} from '../hooks/useTeacherInvite';

export default function LoginPage() {
  const { teacherParam, teacherInfo, teacherWarning, teacherLoading } = useTeacherInvite();
  const { user, authLoading, binding, bindError, isOwnLink } = useBindLoggedInToTeacher(teacherInfo);

  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const registerHref = teacherParam
    ? `/register?teacher=${encodeURIComponent(teacherParam)}`
    : '/register';

  async function handleSubmit(e) {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const extra = teacherInfo?.username ? { teacher: teacherInfo.username } : {};
      await login(username, password, extra);
      navigate('/dashboard');
    } catch (err) {
      setError(err.response?.data?.detail || err.response?.data?.error || 'Неверные учётные данные');
    } finally {
      setLoading(false);
    }
  }

  if (teacherParam && (authLoading || teacherLoading)) {
    return (
      <div className="loading-screen">
        <div className="spinner" />
        <p>Загрузка...</p>
      </div>
    );
  }

  if (user && teacherParam && isOwnLink) {
    return (
      <div className="auth-page">
        <div className="auth-card">
          <h2>Ваша ссылка для учеников</h2>
          <p className="auth-subtitle">Отправьте её ученику — это не форма входа для вас.</p>
          <Link to="/teacher" className="btn btn-primary btn-full">В кабинет</Link>
        </div>
      </div>
    );
  }

  if (user && teacherInfo) {
    return (
      <div className="auth-page">
        <div className="auth-card">
          <h2>Привязка к преподавателю</h2>
          {bindError && <div className="alert alert-error">{bindError}</div>}
          <p className="auth-subtitle">
            {binding
              ? `Привязываем к преподавателю ${teacherDisplayName(teacherInfo)}…`
              : `Вы вошли как ${user.username}.`}
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="auth-page">
      <div className="auth-card">
        <h2>Вход в систему</h2>
        <p className="auth-subtitle">Войдите, чтобы продолжить обучение</p>
        {teacherInfo && (
          <div className="alert alert-info" style={{ marginBottom: '1rem' }}>
            После входа вы станете учеником преподавателя{' '}
            <strong>{teacherDisplayName(teacherInfo)}</strong>
            {teacherInfo.username ? ` (@${teacherInfo.username})` : ''}.
          </div>
        )}
        {teacherWarning && (
          <div className="alert alert-error" style={{ marginBottom: '1rem' }}>
            {teacherWarning}
          </div>
        )}
        {error && <div className="alert alert-error">{error}</div>}
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="username">Имя пользователя</label>
            <input
              id="username"
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              placeholder="Введите имя пользователя"
              required
              autoFocus
            />
          </div>
          <div className="form-group">
            <label htmlFor="password">Пароль</label>
            <input
              id="password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Введите пароль"
              required
            />
          </div>
          <button type="submit" className="btn btn-primary btn-full" disabled={loading}>
            {loading ? 'Вход...' : teacherInfo ? 'Войти и привязаться' : 'Войти'}
          </button>
        </form>
        <p className="auth-link">
          Нет аккаунта? <Link to={registerHref}>Зарегистрироваться</Link>
        </p>
      </div>
    </div>
  );
}
